var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mb12"},[_c('div',{staticClass:"f14 f-info-grey required w86 lh-32"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"flex-1 lh-32"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }